<template>
	<div>
		<div class="content">
			<div class="ssht-title  u-text-center">赛事活动</div>
			<div class="u-text-center title_tips">精彩纷呈的设计活动及赛事</div>
			<div class="ssht">
				<div class="ssht-c  listHover" @click="toDetails(item)" :class="{sshtCB:index<5}"
					v-for="(item,index) in list " :key="index">
					<div class="s_list_img ">
						<el-image class="" fit="cover" :src="item.picture" />
					</div>
					<div class="s_list_con">
						<div class="el-row--flex is-justify-space-between is-align-middle">
							<div class="s-list-t">{{item.eventName}}</div>
							<div class="s-list-s" v-if="item.runStatus == 1">进行中</div>
							<div class="s-list-s2" v-if="item.runStatus == 2">已结束</div>
						</div>
						<div class="introduce">
							<div class="introducecon">
								{{item.introduce}}
							</div>
						</div>
						<div class="list-time">投稿时间：{{$dayjs(item.startTime).format('YYYY.MM.DD')}} -
							{{$dayjs(item.endTime).format('YYYY.MM.DD')}}
						</div>
						<div class="list-f el-row--flex is-justify-space-between is-align-middle">
							<div class="is_lock" v-if="item.runStatus == 1">
								<i class="el-icon-alarm-clock"></i>
								<span>已开始{{getDifferTime(item.startTime)>0?getDifferTime(item.startTime)+'天':''}}</span>
							</div>
							<div v-if="item.runStatus == 2"><i class="el-icon-alarm-clock"></i>已结束</div>
							<div class="el-row--flex is-justify-space-between is-align-middle">
								<div class="lfr" v-if="item.num != 0 || item.runStatus !=2 ">{{item.num}}人参加</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="u-text-center btn_box">
				<button class="home_btn" @click="eventClick">查看更多赛事 <i class="el-icon-arrow-right"></i></button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'events',
		components: {},
		data() {
			return {
				list: []
			};
		},
		created() {
			this.getlist()
		},
		methods: {
			getDifferTime(startDate, endDate) {
				let startTime = new Date(Date.parse(this.$dayjs(startDate).format('YYYY-MM-DD'))).getTime();
				let endTime = new Date(Date.parse(this.$dayjs().format('YYYY-MM-DD'))).getTime()
				let dates = Math.abs((startTime - endTime)) / (1000 * 60 * 60 * 24);
				return dates;
			},
			async getlist() {
				const res = await this.$axios.get('/front/listEvent', {
					pageNum: 1,
					pageSize: 6,
					isTop: 0
				})
				this.list = res.rows
			},
			toDetails(item) {
				const {
					href
				} = this.$router.resolve({
					name: 'activetydetails',
					query: {
						eventId: item.eventId
					}
				})
				window.open(href, '_blank')
			},
			eventClick() {
				const {
					href
				} = this.$router.resolve({
					name: 'eventsmore'
				})
				window.open(href, '_blank')
			}
		}
	}
</script>
<style lang="scss" scoped>
	.btn_box {
		margin: 40px 0 80px 0;
	}

	.ssht-title {
		margin: 120px 0 0 0;
		font-size: 40px;
		text-align: center;
	}

	.ssht:after {
		content: '';
		display: block;
		clear: both;
	}

	.ssht {
		margin-top: 60px;
		cursor: pointer;

		.ssht-c {
			width: 32%;
			overflow: hidden;
			float: left;
			margin-right: 2%;
			background-color: var(--white);
			border-radius: 10px;

			.s_list_img {
				overflow: hidden;

				.el-image {
					border-radius: 6px;
					margin: 20px 20px 10px 20px;
					height: 200px;
				}

			}


			.s_list_con {
				padding: 10px 20px;

				.s-list-t {
					font-size: 18px;
					font-weight: bold;
					flex: 1;
					overflow: hidden;
					color: var(--black);
					text-overflow: ellipsis;
					white-space: nowrap;
					margin-right: 30px;
				}

				.introduce {
					background-color: var(--bg);
					padding: 10px;
					margin-top: 14px;

					.introducecon {
						font-size: 13px;
						color: var(--info);
						line-height: 20px;
						border-radius: 4px;
						height: 40px;
						overflow: hidden;
					}
				}

				.s-list-s {
					line-height: 24px;
					padding: 0 6px;
					border-radius: 2px;
					font-size: 12px;
					color: var(--white);
					background-color: var(--brand);
				}

				.s-list-s2 {
					line-height: 24px;
					padding: 0 6px;
					border-radius: 2px;
					font-size: 12px;
					color: var(--brand);
					background-color: var(--hovbg);
					border: 1px solid var(--hovbg);
					color: var(--info)
				}

				.list-time {
					padding: 10px 0;
					margin-bottom: 10px;
					border-bottom: 1px solid #E0e0e0;
					color: var(--info);
				}

				.list-f {
					color: var(--info);
					padding: 10px 0;

					.is_lock {
						display: flex;
						align-items: center;
					}

					.lfr {
						margin-left: 10px;
					}

					i {
						margin-right: 4px;
						font-size: 16px;
					}
				}
			}

			&:hover {
				.s-list-t {
					color: var(--brand);
				}
			}
		}

		.sshtCB {
			margin-bottom: 2%;
		}

		.ssht-c:nth-child(3n) {
			margin-right: 0;
		}
	}
</style>
